import React, { Component } from 'react';

import './NavMenu.css';
import { MenuItem } from './MenuItem';

export class DropdownMenuItem extends Component {
    clickHandler(str, callback) {
        callback(str);
    }

    renderMenuItens(show, items, app) {
        if (!show) {
            return null;
        }

        return (
            <div>
                {items.map((item, i) =>
                    <MenuItem
                        key={i}
                        icon={item.icon}
                        label={item.label}
                        to={item.to}
                        app={app}
                        hidden={item.hidden}
                        showMetadata={item.showMetadata}
                    />)}
            </div>
        );
    }

    render() {
        const { data, app, dropdownId, showItems, onClickHandler, hidden } = this.props;

        if (!hidden) {
            return (
                <div>
                    <div onClick={() => onClickHandler(dropdownId)}>
                        <MenuItem
                            icon={data.icon}
                            label={data.label}
                            to="#"
                            app={app}
                            showMetadata={data.showMetadata}
                        />
                    </div>
                    <div className={`icon-nav-item-dropdown ${showItems ? "open" : ""}`}>
                        {this.renderMenuItens(showItems, data.items, app, onClickHandler)}
                    </div>
                </div>

            );
        } else {
            return null;
        }
    }
}
